import scenes from 'helpers/fovPreview/scenes'

export default function sceneUrl({ sceneName, streetViewUrl, streetViewActive, userUploadedSceneActive, userUploadedSceneUrl, horizontalAngleOfView, userSelectedGeneralScene, model }) {
  if (userUploadedSceneActive) return userUploadedSceneUrl
  else if (streetViewActive) return streetViewUrl
  else if (userSelectedGeneralScene) return scenes[sceneName]
  else if (model && model.is_fisheye) return (horizontalAngleOfView === 180 ? scenes['180'] : scenes['360'])
  else if (horizontalAngleOfView > 180) return scenes['360']
  else return scenes[sceneName]
}



// WEBPACK FOOTER //
// ./src/helpers/fovPreview/sceneUrl.js